import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSiteMetadata } from '../hooks/use-site-metadata';
import { PageLabel } from './third-party/speedcurve/';
import { monetateDataLayer } from './utilities/functions';

export const SEO = ({ title, description, keywords, thumbnail, image, noIndex, pageLabel, type, trail }) => {
	const { title: defaultTitle, description: defaultDescription, logo } = useSiteMetadata();
	const showTrail = trail ? trail : 'Pella';
	const seoTitle = title ? `${title} | ${showTrail}` : defaultTitle ? `${defaultTitle} | ${showTrail}` : showTrail;

	useEffect(() => {
		if (pageLabel) monetateDataLayer('setPageType', `${pageLabel.replace(/ /g, '-')}`);
		setTimeout(() => monetateDataLayer('trackData'));
	}, [pageLabel]);	

	return (
		<>
			<title>{seoTitle}</title>
			<meta
				name='description'
				content={description || defaultDescription}
			/>
			<meta
				name='keywords'
				content={keywords}
			/>
			{(image || thumbnail?.url) && (
				<meta
					name='image'
					content={image || thumbnail.url}
				/>
			)}
			<meta
				property='og:title'
				content={title || defaultTitle}
			/>
			<meta
				property='og:description'
				content={description || defaultDescription}
			/>
			<meta
				property='og:type'
				content={type || 'website'}
			/>
			<meta
				property='og:logo'
				content={logo}
			/>
			{(image || thumbnail?.url) && (
				<meta
					property='og:image'
					content={image || thumbnail.url}
				/>
			)}
			{typeof window !== 'undefined' && (
				<meta
					property='og:url'
					content={window.location.origin + window.location.pathname}
				/>
			)}
			<meta
				name='twitter:card'
				content='summary_large_image'
			/>
			<meta
				name='twitter:title'
				content={title || defaultTitle}
			/>
			<meta
				name='twitter:description'
				content={description || defaultDescription}
			/>
			{(image || thumbnail?.url) && (
				<meta
					name='twitter:image'
					content={image || thumbnail.url}
				/>
			)}
			{noIndex && (
				<meta
					name='robots'
					content='noindex'
				/>
			)}
			{pageLabel && <PageLabel label={pageLabel} />}
		</>
	);
};

SEO.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
	keywords: PropTypes.string,
	thumbnail: PropTypes.object,
	image: PropTypes.string,
	noIndex: PropTypes.bool,
	pageLabel: PropTypes.string,
	type: PropTypes.string,
	trail: PropTypes.string,
};

export default SEO;
